import React from 'react'
import { Box } from '@mui/material'
import { CheckpointCard } from '@/apps/legacy/components/molecules/CheckpointCard'
import {
  useCheckpointsQuery,
  useCheckpointSelectionActions,
} from '@/apps/legacy/features/guidance/hooks/queries/useCheckpointsQuery'
import { CHECKPOINT_STYLES } from '@/apps/legacy/constants/styles/checkpoint'

interface CheckpointCardContainerProps {
  requestId: string
}

export const CheckpointCardContainer: React.FC<
  CheckpointCardContainerProps
> = ({ requestId }) => {
  const { data, isLoading, error } = useCheckpointsQuery(requestId)
  const checkpoints = data ?? []

  const { syncSelections, isUpdating } = useCheckpointSelectionActions(
    requestId,
    checkpoints
  )

  const selectedIds = checkpoints
    .filter((checkpoint) => checkpoint.isSelected)
    .map((checkpoint) => checkpoint.id)

  const handleSelectionChange = (newSelectedIds: string[]) => {
    syncSelections(newSelectedIds)
  }

  if (isLoading || isUpdating) {
    return <Box sx={{ p: 2, textAlign: 'center' }}>読み込み中...</Box>
  }

  // アクセス権限エラーの場合の表示
  if (error?.hasAccessError) {
    return (
      <Box
        sx={{
          p: 2,
          textAlign: 'center',
          color: CHECKPOINT_STYLES.EMPTY_STATE_COLOR,
          fontSize: CHECKPOINT_STYLES.EMPTY_STATE_FONT_SIZE,
        }}
      >
        このデータへのアクセス権限がありません。
        <br />
        ご自身が作成したデータまたは同一薬局のデータのみ閲覧可能です。
      </Box>
    )
  }

  // その他のエラーの場合
  if (error) {
    return (
      <Box
        sx={{
          p: 2,
          textAlign: 'center',
          color: CHECKPOINT_STYLES.EMPTY_STATE_COLOR,
          fontSize: CHECKPOINT_STYLES.EMPTY_STATE_FONT_SIZE,
        }}
      >
        {error.message}
      </Box>
    )
  }

  if (checkpoints.length === 0) {
    return (
      <Box
        sx={{
          p: 2,
          textAlign: 'center',
          color: CHECKPOINT_STYLES.EMPTY_STATE_COLOR,
          fontSize: CHECKPOINT_STYLES.EMPTY_STATE_FONT_SIZE,
        }}
      >
        ピックアップされた確認事項は現在ありません。
        <br />
        患者データ蓄積に応じて各種加算に関する過去情報ピックアップなどを行います。
      </Box>
    )
  }

  return (
    <CheckpointCard
      checkpoints={checkpoints}
      selectedIds={selectedIds}
      onSelectionChange={handleSelectionChange}
    />
  )
}
